// add this import near the top with the others
import StaffDev from './staff_dev';
import './ai-modal.css';
// add this import near the top with the others
import RouteAnalysis from "./route_analysis";
import Services from "./services"; // <-- ADDED
import SMSQueue from "./SMSQueue";
import PwaDev from "./pwa_dev";
import SOPUpload from "./SOPUpload"; // <-- ADDED: SOP Upload & Cascade

import React, { useState, useMemo, useRef, useEffect } from "react";
import Login from "./Login";
import QMap from "./QMap";
import StockFinancials from "./stock_financials";
import StockGraphs from "./stock_graphs";
import Mockup from "./Mockupp";
import StockExcess from "./stock_excess";
import ShelfPictorialView from "./shelfPictoriallView";
import Pickups from "./pickups";
import Settings from "./settings";
import Shelves from "./shelves";
import Updates from './updates';
import Stafflogin from './stafflogin';
import Sms from './sms';
import SmsProd from './smsprod';
import Sitedetails from './sitedetails';
import DriverRoute from "./driverroute";
import ApptsAnalysis from "./appts_analysis"; // <-- added
import Epos from "./epos"; // <-- added
import Nms from "./nms"; // <-- added
import HeadOffice from "./HeadOffice"; // <-- added: fleet dashboard
import SinglePharmacy from "./SinglePharmacy"; // <-- added: single-pharmacy view
import Staff from "./Staff"; // <-- added: staff roster + appraisals
import Workforce from "./Workforce"; // <-- added: hours per 1000 items grid
import Inspection from "./Inspection"; // <-- added: branch inspection workbench
import Config from "./Config"; // <-- added: configurables admin
import PeriodicEntries from "./PeriodicEntries"; // <-- added: periodic data entry CRUD

import QuestionBox from "./QuestionBox";
import "./App.css";

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const App = () => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [userData, setUserData] = useState(null);
  const [currentView, setCurrentView] = useState("mockup");
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [shelvesOpen, setShelvesOpen] = useState(false);
  const [answer, setAnswer] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [loadingAnswer, setLoadingAnswer] = useState(false);
  const [clarificationOptions, setClarificationOptions] = useState(null);
  const [selectedPharmacy, setSelectedPharmacy] = useState("");
  const [selectedMetric, setSelectedMetric] = useState("");
  const [showStockMenu, setShowStockMenu] = useState(false);

  // Unified state for the categorised dropdown menus.
  // Only one dropdown is open at a time. Click-outside closes it.
  const [openMenu, setOpenMenu] = useState(null); // "operations" | "stock" | "compliance" | "services" | "communications" | "admin" | null
  const navRef = useRef(null);

  // Pale-grey button style for the left nav rail (beats global blue button rule via inline style)
  const navBtnStyle = {
    backgroundColor: "#f3f4f6",
    color: "#374151",
    border: "1px solid #d1d5db",
    borderRadius: 4,
    padding: "6px 10px",
    fontSize: 14,
    textAlign: "left",
    width: "100%",
    cursor: "pointer"
  };

  useEffect(() => {
    function handleClickOutside(e) {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Helper: choose a view and close any open dropdown
  const [navParams, setNavParams] = useState(null);
  const goTo = (view, params = null) => {
    setCurrentView(view);
    setNavParams(params);
    setOpenMenu(null);
  };

  // Pagination & Sorting & Filtering
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;
  const [sortKey, setSortKey] = useState("");
  const [sortAsc, setSortAsc] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [question, setQuestion] = useState("");

  const handleShelvesClick = () => setShelvesOpen(true);
  const handleSettingsClick = () => setSettingsOpen(true);
  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken(null);
  };

  const handleAskQuestion = async (question) => {
    if (!question.trim()) return;
    setQuestion(question);
    setLoadingAnswer(true);
    setClarificationOptions(null);
    setAnswer("");
    setCurrentPage(1);
    const members = JSON.parse(localStorage.getItem("members") || "[]");
    try {
      const res = await fetch("https://api.pharmacegroup.co.uk/aiquery", {
        method: "POST",
        headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
        body: JSON.stringify({ question, members })
      });

      if (!res.ok) {
        console.error("Server returned an error status:", res.status);
        setAnswer(`Server error: ${res.status}`);
        setShowDialog(true);
        return;
      }

      const data = await res.json();
      if (data.needClarification) {
        setClarificationOptions({
          message: data.message,
          missingFields: data.missingFields
        });
        return;
      }

      setAnswer(data.answer || "No response received.");
      setShowDialog(true);

      await fetch("https://api.pharmacegroup.co.uk/savequestion", {
        method: "POST",
        headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
        body: JSON.stringify({
          groupId: localStorage.getItem("userId"),
          question
        })
      });
    } catch (error) {
      console.error("Error during /aiquery fetch:", error);
      setAnswer("An error occurred while fetching data.");
      setShowDialog(true);
    } finally {
      setLoadingAnswer(false);
    }
  };

  const handleClarifiedQuery = async () => {
    if (!selectedPharmacy || !selectedMetric) return;
    const newQuestion = `What is the ${selectedMetric} at ${selectedPharmacy}?`;
    await handleAskQuestion(newQuestion);
  };


  const handleExportToExcel = () => {
    if (!Array.isArray(answer) || answer.length === 0) return;

    const exportData = answer.map(item => {
      const filtered = {};
      for (const [key, value] of Object.entries(item)) {
        if (["_id", "log"].includes(key)) continue;
        if (["price", "value", "totalPrice", "totalValue"].includes(key) && typeof value === "number") {
          filtered[key] = (value / 100).toFixed(2);
        } else {
          filtered[key] = value;
        }
      }
      return filtered;
    });

    import("xlsx").then((xlsx) => {
      const workbook = xlsx.utils.book_new();
      const worksheet = {};

      const groupName = localStorage.getItem("organisationName") || "Group";
      const now = new Date();
      const formatted = now.toLocaleString("en-GB", {
        day: "2-digit", month: "2-digit", year: "2-digit",
        hour: "2-digit", minute: "2-digit"
      });
      const questionPrompt = question || "";

      const headerRows = [
        [groupName],
        [`Generated at: ${formatted}`],
        [`Prompt: ${questionPrompt}`],
        []
      ];
      xlsx.utils.sheet_add_aoa(worksheet, headerRows, { origin: "A1" });

      const headers = Object.keys(exportData[0] || {});
      xlsx.utils.sheet_add_aoa(worksheet, [headers], { origin: "A5" });

      xlsx.utils.sheet_add_json(worksheet, exportData, {
        origin: "A6",
        skipHeader: true
      });

      const allRows = [...headerRows, headers, ...exportData.map(obj => headers.map(k => obj[k] ?? ""))];
      worksheet["!cols"] = headers.map((_, colIdx) => {
        const maxLength = allRows.reduce((max, row) => {
          const val = row[colIdx];
          const len = val ? String(val).length : 0;
          return Math.max(max, len);
        }, 10);
        return { wch: maxLength + 2 };
      });

      xlsx.utils.book_append_sheet(workbook, worksheet, "AI_Results");
      xlsx.writeFile(workbook, "AI_Response.xlsx");
    });
  };

  const filteredAndSorted = useMemo(() => {
    if (!Array.isArray(answer)) return [];

    let result = [...answer];

    if (filterText) {
      result = result.filter(row =>
        Object.values(row).some(val =>
          String(val).toLowerCase().includes(filterText.toLowerCase())
        )
      );
    }

    if (sortKey) {
      result.sort((a, b) => {
        const valA = a[sortKey];
        const valB = b[sortKey];
        if (valA == null) return 1;
        if (valB == null) return -1;
        if (typeof valA === "number" && typeof valB === "number") {
          return sortAsc ? valA - valB : valB - valA;
        }
        return sortAsc
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      });
    }

    return result;
  }, [answer, filterText, sortKey, sortAsc]);

  const totalPages = Math.ceil(filteredAndSorted.length / pageSize);
  const paginatedAnswer = filteredAndSorted.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="app-container">
        {!token ? (
          <Login setToken={setToken} setUserData={setUserData} />
        ) : (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "15px", marginTop: "20px", marginBottom: "10px", flexWrap: "nowrap" }}>
              <h2 className="group-title" style={{ margin: 0, whiteSpace: "nowrap" }}>
                {localStorage.getItem("organisationName") || "Group"} management tools
              </h2>
              <QuestionBox onAsk={handleAskQuestion} />
            </div>

            {/* ── Layout split: left navigation rail + right content area ── */}
            <style>{`
              .nav-rail button {
                background-color: #f3f4f6;
                color: #374151;
                border: 1px solid #d1d5db;
                border-radius: 4px;
                padding: 6px 10px;
                font-size: 14px;
                cursor: pointer;
              }
              .nav-rail button:hover {
                background-color: #e5e7eb;
              }
            `}</style>
            <div style={{ display: "flex", alignItems: "flex-start", gap: "15px" }}>
              {/* Left nav rail */}
              <div
                ref={navRef}
                className="nav-rail"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  flexShrink: 0,
                  width: 180,
                  padding: "10px",
                  background: "#f8fafc",
                  border: "1px solid #e5e7eb",
                  borderRadius: 6,
                  position: "sticky",
                  top: 10,
                  alignSelf: "flex-start"
                }}
              >
                {/* Site Activity — most-used, kept standalone */}
                <button onClick={() => goTo("mockup")} style={navBtnStyle}>Site Activity</button>

                {/* Head Office — fleet dashboard for /api/headoffice/* */}
                <button onClick={() => goTo("head_office")} style={navBtnStyle}>Head Office</button>

                {/* Single pharmacy — Head-Office-style view scoped to one pharmacy */}
                <button onClick={() => goTo("single_pharmacy")} style={navBtnStyle}>Single pharmacy</button>

                {/* Workforce — hours per 1000 items by role */}
                <button onClick={() => goTo("workforce")} style={{ ...navBtnStyle, backgroundColor: "#fef3c7" }}>Workforce</button>

                {/* Inspection — branch inspection workbench */}
                <button onClick={() => goTo("inspection")} style={{ ...navBtnStyle, backgroundColor: "#fef3c7" }}>Inspection</button>

                {/* Operations */}
                <div>
                  <button onClick={() => setOpenMenu(openMenu === "operations" ? null : "operations")} style={navBtnStyle}>
                    Operations {openMenu === "operations" ? "▼" : "▶"}
                  </button>
                  {openMenu === "operations" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, marginLeft: 12, marginTop: 4 }}>
                      <button onClick={() => goTo("qmap")} style={navBtnStyle}>Map</button>
                      <button onClick={() => goTo("pickups")} style={navBtnStyle}>Collection times</button>
                    </div>
                  )}
                </div>

                {/* Stock */}
                <div>
                  <button onClick={() => setOpenMenu(openMenu === "stock" ? null : "stock")} style={navBtnStyle}>
                    Stock {openMenu === "stock" ? "▼" : "▶"}
                  </button>
                  {openMenu === "stock" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, marginLeft: 12, marginTop: 4 }}>
                      <button onClick={() => goTo("stock_financials")} style={navBtnStyle}>Financials</button>
                      <button onClick={() => goTo("shelfPictorialView")} style={navBtnStyle}>Pictorial</button>
                      <button onClick={() => goTo("stock_excess")} style={navBtnStyle}>Excess</button>
                      <button onClick={() => { handleShelvesClick(); setOpenMenu(null); }} style={navBtnStyle}>Stock Shelves</button>
                    </div>
                  )}
                </div>

                {/* Services */}
                <div>
                  <button onClick={() => setOpenMenu(openMenu === "services" ? null : "services")} style={navBtnStyle}>
                    Services {openMenu === "services" ? "▼" : "▶"}
                  </button>
                  {openMenu === "services" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, marginLeft: 12, marginTop: 4 }}>
                      <button onClick={() => goTo("services")} style={navBtnStyle}>Services / Appts analysis</button>
                      <button onClick={() => goTo("nms")} style={navBtnStyle}>NMS</button>
                      <button onClick={() => goTo("epos")} style={navBtnStyle}>EPOS</button>
                      <button onClick={() => goTo("route_analysis")} style={navBtnStyle}>Route analysis</button>
                      <button onClick={() => goTo("stafflogin")} style={navBtnStyle}>Staff clocking in/out</button>
                    </div>
                  )}
                </div>

                {/* Communications */}
                <div>
                  <button onClick={() => setOpenMenu(openMenu === "communications" ? null : "communications")} style={navBtnStyle}>
                    Communications {openMenu === "communications" ? "▼" : "▶"}
                  </button>
                  {openMenu === "communications" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, marginLeft: 12, marginTop: 4 }}>
                      <button onClick={() => goTo("smsprod")} style={navBtnStyle}>SMS history</button>
                    </div>
                  )}
                </div>

                {/* Admin — gated by Pharmace all */}
                {(localStorage.getItem("organisationName") || "").trim() === "Pharmace all" && (
                  <div>
                    <button onClick={() => setOpenMenu(openMenu === "admin" ? null : "admin")} style={navBtnStyle}>
                      Admin {openMenu === "admin" ? "▼" : "▶"}
                    </button>
                    {openMenu === "admin" && (
                      <div style={{ display: "flex", flexDirection: "column", gap: 4, marginLeft: 12, marginTop: 4 }}>
                        <button onClick={() => goTo("sms")} style={navBtnStyle}>SMS dev</button>
                        <button onClick={() => goTo("staff_dev")} style={navBtnStyle}>STAFF dev</button>
                        <button onClick={() => goTo("pwa_dev")} style={navBtnStyle}>PWA dev</button>
                        <button onClick={() => goTo("sms_queue")} style={navBtnStyle}>SMS queue</button>
                        <button onClick={() => goTo("sitedetails")} style={navBtnStyle}>Site details</button>
                      </div>
                    )}
                  </div>
                )}

                {/* Spacer pushes Settings/Log out to the bottom */}
                <div style={{ flexGrow: 1, minHeight: 20 }}></div>

                {/* Settings */}
                <div>
                  <button onClick={() => setOpenMenu(openMenu === "settings" ? null : "settings")} style={navBtnStyle}>
                    Settings {openMenu === "settings" ? "▼" : "▶"}
                  </button>
                  {openMenu === "settings" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, marginLeft: 12, marginTop: 4 }}>
                      <button onClick={() => goTo("sop_upload")} style={navBtnStyle}>SOP Upload</button>
                      <button onClick={() => goTo("config")} style={navBtnStyle}>Configurables</button>
                      <button onClick={() => { handleSettingsClick(); setOpenMenu(null); }} style={navBtnStyle}>Settings</button>
                    </div>
                  )}
                </div>

                <button onClick={handleLogout} style={navBtnStyle}>Log out</button>
              </div>

              {/* Right content area */}
              <div style={{ flex: 1, minWidth: 0 }}>

            {clarificationOptions && (
              <div style={{ marginTop: 20 }}>
                <p>{clarificationOptions.message}</p>
                {clarificationOptions.missingFields.includes("pharmacy name") && (
                  <>
                    <label>Choose Pharmacy: </label>
                    <select value={selectedPharmacy} onChange={(e) => setSelectedPharmacy(e.target.value)}>
                      <option value="">--Select--</option>
                      <option value="Oxford Pharmacy">Oxford Pharmacy</option>
                      <option value="High Street Pharmacy">High Street Pharmacy</option>
                      <option value="City Centre Pharmacy">City Centre Pharmacy</option>
                    </select>
                  </>
                )}
                {clarificationOptions.missingFields.includes("metric") && (
                  <>
                    <label> Choose Metric: </label>
                    <select value={selectedMetric} onChange={(e) => setSelectedMetric(e.target.value)}>
                      <option value="">--Select--</option>
                      <option value="totalCost">Total Cost</option>
                      <option value="count">Count</option>
                      <option value="totalPackets">Total Packets</option>
                      <option value="averagePrice">Average Price</option>
                      <option value="expiringSoon">Expiring Soon</option>
                    </select>
                  </>
                )}
                <button
                  onClick={handleClarifiedQuery}
                  disabled={
                    (clarificationOptions.missingFields.includes("pharmacy name") && !selectedPharmacy) ||
                    (clarificationOptions.missingFields.includes("metric") && !selectedMetric)
                  }
                  style={{ marginLeft: "10px" }}
                >
                  Submit Clarified Query
                </button>
              </div>
            )}

            {currentView === "mockup" && <Mockup userData={userData} />}
            {currentView === "head_office" && <HeadOffice token={token} />}
            {currentView === "single_pharmacy" && <SinglePharmacy token={token} goTo={goTo} />}
            {currentView === "staff" && <Staff token={token} userData={userData} />}
            {currentView === "workforce" && <Workforce token={token} userData={userData} />}
            {currentView === "inspection" && <Inspection token={token} userData={userData} />}
            {currentView === "config" && <Config token={token} />}
            {currentView === "sop_upload" && <SOPUpload />}
            {currentView === "periodic_entries" && <PeriodicEntries token={token} />}
            {currentView === "qmap" && <QMap userData={userData} />}
            {currentView === "stock_financials" && <StockFinancials userData={userData} />}
            {currentView === "shelfPictorialView" && <ShelfPictorialView userData={userData} />}
            {currentView === "stock_graphs" && <StockGraphs userData={userData} />}
            {currentView === "stock_excess" && <StockExcess userData={userData} />}
            {currentView === "pickups" && <Pickups userData={userData} />}
            {currentView === "stafflogin" && <Stafflogin userData={userData} />}
            {currentView === "smsprod" && <SmsProd userData={userData} />}
            {currentView === "sms" && <Sms userData={userData} />}
            {currentView === "sms_queue" && <SMSQueue userData={userData} />}
            {currentView === "staff_dev" && <StaffDev userData={userData} />}
            {currentView === "pwa_dev" && <PwaDev userData={userData} />}
            {currentView === "route_analysis" && <RouteAnalysis userData={userData} initialPharmacyName={navParams?.pharmacyName} />}

            {currentView === "services" && <Services userData={userData} />} {/* <-- ADDED */}
      {currentView === "nms" && <Nms userData={userData} />} {/* <-- ADDED */}
            {currentView === "appts_analysis" && <ApptsAnalysis userData={userData} />}
            {currentView === "epos" && <Epos userData={userData} />}
            {currentView === "sitedetails" && <Sitedetails userData={userData} />}
            {currentView === "updates" && <Updates userData={userData} />}
              </div>
            </div>

            <Shelves open={shelvesOpen} onClose={() => setShelvesOpen(false)} />
            <Settings open={settingsOpen} onClose={() => setSettingsOpen(false)} />

            {showDialog && (
              <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                zIndex: 1000
              }}>
                <div style={{
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  maxWidth: "90vw",
                  maxHeight: "90vh",
                  overflowY: "auto",
                  marginTop: "30px"
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                    <h3 style={{ margin: 0 }}>AI Response - </h3>
                    <div>
                      <button onClick={handleExportToExcel} style={{ marginRight: "10px" }}>Export to Excel</button>
                      <button onClick={() => setShowDialog(false)}>Close</button>
                    </div>
                  </div>

                  {Array.isArray(answer) && (
                    <>
                      <input
                        type="text"
                        placeholder="Search..."
                        value={filterText}
                        onChange={(e) => { setFilterText(e.target.value); setCurrentPage(1); }}
                        style={{ marginBottom: "10px", padding: "5px", width: "100%" }}
                      />
                      <div style={{ overflowX: "auto" }}>
                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                          <thead>
                            <tr>
                              {Object.keys(answer[0] || {}).filter(k => !["_id", "id", "log"].includes(k)).map((key) => (
                                <th key={key}
                                  onClick={() => {
                                    if (sortKey === key) {
                                      setSortAsc(!sortAsc);
                                    } else {
                                      setSortKey(key);
                                      setSortAsc(true);
                                    }
                                  }}
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f2f2f2",
                                    textTransform: "capitalize",
                                    cursor: "pointer"
                                  }}>
                                  {key} {sortKey === key ? (sortAsc ? "↑" : "↓") : ""}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedAnswer.map((item, index) => (
                              <tr key={index}>
                                {Object.entries(item).filter(([k]) => !["_id", "id", "log"].includes(k)).map(([key, value]) => {
                                  let displayValue = value;
                                  if (["price", "value", "totalPrice", "totalValue"].includes(key) && typeof value === "number") {
                                    displayValue = `£${(value / 100).toFixed(2)}`;
                                  } else if (typeof value === "object") {
                                    displayValue = JSON.stringify(value);
                                  } else {
                                    displayValue = String(value);
                                  }

                                  const isTruncatable = ["vmppNm", "amppNm"].includes(key) && displayValue.length > 25;
                                  const cellText = isTruncatable ? displayValue.slice(0, 25) + "…" : displayValue;

                                  return (
                                    <td
                                      key={key}
                                      style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        maxWidth: "200px",
                                        overflowWrap: "break-word"
                                      }}
                                      title={isTruncatable ? displayValue : ""}
                                    >
                                      {cellText}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div style={{ marginTop: "10px", textAlign: "center" }}>
                        <button onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>Prev</button>
                        <span style={{ margin: "0 10px" }}>Page {currentPage} of {totalPages}</span>
                        <button onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>Next</button>
                      </div>
                    </>
                  )}

                  {!Array.isArray(answer) && (
                    <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                      {loadingAnswer ? "Searching..." : answer}
                    </pre>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </LocalizationProvider>
  );
};

export default App;